module.exports = __webpack_public_path__ + "img/ss.014c4b10.png";